import produce from "immer";
import { IStoreState } from "../../initialStoreState";
import { LoadState } from "../../../constants/enums";
import { initialAccountingPaymentAccountsRecievableState } from "./PaymentAccountsRecievable.types";
import { AccountingPaymentAccountsRecievableActions } from ".";
import {
  CLEAR_ACCOUNTING_PAYMENT_ACCOUNTS_RECIEVABLE,
  FETCH_ACCOUNTING_PAYMENT_ACCOUNTS_RECIEVABLE_FAILURE,
  FETCH_ACCOUNTING_PAYMENT_ACCOUNTS_RECIEVABLE_LIST_FAILURE,
  FETCH_ACCOUNTING_PAYMENT_ACCOUNTS_RECIEVABLE_LIST_PROGRESS,
  FETCH_ACCOUNTING_PAYMENT_ACCOUNTS_RECIEVABLE_LIST_SUCCESS,
  FETCH_ACCOUNTING_PAYMENT_ACCOUNTS_RECIEVABLE_PROGRESS,
  FETCH_ACCOUNTING_PAYMENT_ACCOUNTS_RECIEVABLE_SUCCESS,
  UPDATE_INVOICE_PAYMENT_RECONCILIATION_STATUS,
} from "./PaymentAccountsRecievableActions";

export const AccountingPaymentAccountsRecievableReducer = (
  state: IStoreState["accounting"]["paymentAccountsRecievable"] = initialAccountingPaymentAccountsRecievableState,
  action: AccountingPaymentAccountsRecievableActions
) => {
  switch (action.type) {
    case FETCH_ACCOUNTING_PAYMENT_ACCOUNTS_RECIEVABLE_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.InProgress;
      });
      return newState;
    }

    case FETCH_ACCOUNTING_PAYMENT_ACCOUNTS_RECIEVABLE_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Loaded;
        draftState.data = data;
      });
      return newState;
    }

    case FETCH_ACCOUNTING_PAYMENT_ACCOUNTS_RECIEVABLE_FAILURE: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Failed;
        draftState.error = errorMessage;
      });
      return newState;
    }

    case FETCH_ACCOUNTING_PAYMENT_ACCOUNTS_RECIEVABLE_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.listLoading = LoadState.InProgress;
      });
      return newState;
    }

    case FETCH_ACCOUNTING_PAYMENT_ACCOUNTS_RECIEVABLE_LIST_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.listLoading = LoadState.Loaded;
        draftState.list = data;
      });
      return newState;
    }

    case FETCH_ACCOUNTING_PAYMENT_ACCOUNTS_RECIEVABLE_LIST_FAILURE: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.listLoading = LoadState.Failed;
      });
      return newState;
    }

    // case UPDATE_INVOICE_PAYMENT_RECONCILIATION_STATUS: {
    //   const {paymentId, reconciled, reconciledDate} = action.payload;
    //     const newState = produce(state, (draftState) => {
    //      const index = draftState.list.findIndex(x=>x.payment_id === paymentId as any);
    //      if(index > -1){
    //       draftState.list[index].reconciled = reconciled;
    //       draftState.list[index].reconciled_date = reconciledDate;
    //      }
    //   });
    //   return newState;
    // }

    case UPDATE_INVOICE_PAYMENT_RECONCILIATION_STATUS: {
      const { paymentIds, reconciled, reconciledDate } = action.payload;
      const newState = produce(state, (draftState) => {
        paymentIds.forEach((id: number) => {
          const index = draftState.list.findIndex(x => x.accn_invoice_payment_accounts_receivable_id === id);
          if (index > -1) {
            draftState.list[index].reconciled = reconciled;
            draftState.list[index].reconciled_date = reconciledDate;
          }
        });
      });
      return newState;
    }

    
    case CLEAR_ACCOUNTING_PAYMENT_ACCOUNTS_RECIEVABLE: {
      return initialAccountingPaymentAccountsRecievableState;
    }

    default:
      return state;
  }
};
